/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'dumPgVWfcxjAoJ5EAYoTPG.png': { uri: '/images/dumPgVWfcxjAoJ5EAYoTPG.png' },
'p6LS2wXPyviLdWR5eHPLjJ.png': { uri: '/images/p6LS2wXPyviLdWR5eHPLjJ.png' },
'fziT6u1M75UTKLznVJuWjG.png': { uri: '/images/fziT6u1M75UTKLznVJuWjG.png' },
'mhg2YSzjJ8eQRX1MSgVmT6.png': { uri: '/images/mhg2YSzjJ8eQRX1MSgVmT6.png' },
'xqchcNDMW2eBu14xvUHMYj.png': { uri: '/images/xqchcNDMW2eBu14xvUHMYj.png' },
'hQ5Sh4JAJZ7KFbKJrUb8gc.png': { uri: '/images/hQ5Sh4JAJZ7KFbKJrUb8gc.png' },
'onwkiVAnJ9WFJVmmNWWZLw.png': { uri: '/images/onwkiVAnJ9WFJVmmNWWZLw.png' },
'wdLZspjkJBhdNnMd49i8gj.png': { uri: '/images/wdLZspjkJBhdNnMd49i8gj.png' },
'iR6hf54EQEwkDrCPQqZ55h.png': { uri: '/images/iR6hf54EQEwkDrCPQqZ55h.png' },
'erXoujYcpb8ti9pZAZSiCF.png': { uri: '/images/erXoujYcpb8ti9pZAZSiCF.png' },
'pzn2fhvgo4svsuPFtkz5bR.png': { uri: '/images/pzn2fhvgo4svsuPFtkz5bR.png' },
'aJboU1caxrWtdqoLMiKudE.png': { uri: '/images/aJboU1caxrWtdqoLMiKudE.png' },
'sQs2S27BYjTwXMbwH8ap7B.png': { uri: '/images/sQs2S27BYjTwXMbwH8ap7B.png' },
'5vx3daiQ33U8TJ3xfGpH2G.jpg': { uri: '/images/5vx3daiQ33U8TJ3xfGpH2G.jpg' },
'eXBdvELpB3Hxq38ipnFxpX.png': { uri: '/images/eXBdvELpB3Hxq38ipnFxpX.png' },
'hTCCoXjcJ5GU2fHNeLjpWj.png': { uri: '/images/hTCCoXjcJ5GU2fHNeLjpWj.png' },
'imyX7zo3YU9WsxLsU1mm9N.png': { uri: '/images/imyX7zo3YU9WsxLsU1mm9N.png' },
'1mrTkw8sxTSdTf333NtfRd.png': { uri: '/images/1mrTkw8sxTSdTf333NtfRd.png' },
'pySgbpsGfZSFk4iFvSqFrz.png': { uri: '/images/pySgbpsGfZSFk4iFvSqFrz.png' }
}

export default imageStaticSourcesByFileName
